import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SolvReduxState } from '~/reducers';
import { TouchableInputProps } from '..';
import { analyticsTrackEvent } from '../../../../core/analytics';
import { UNIVERSAL_SEARCH_BUTTON, ACTION_CTA_CLICK } from '../../../../core/analytics/events';
import { REQUEST_UNIVERSAL_SEARCH } from '../../../../sagas/universalSearch';
import LocationInput from '../LocationInput';
import PatientInput from '../PatientInput';
import SearchButton from '../SearchButton';
import UniversalInput from '../UniversalInput';
import WhenInput from '../WhenInput';
import { useLDFlags } from '~/core/launch-darkly/hooks/useLDFlags';
import { isAStructuredRfv } from '../../util';

/**
 * The search fields for an in person visit.
 */
const InPersonForm = ({ touched }: TouchableInputProps) => {
  const dispatch = useDispatch();
  const { universalSearch } = useSelector((state: SolvReduxState) => ({
    universalSearch: state.universalSearch,
  }));
  const { structuredReasonForVisit } = useLDFlags();

  const search = () => {
    analyticsTrackEvent(UNIVERSAL_SEARCH_BUTTON, {
      action: ACTION_CTA_CLICK,
      query: universalSearch?.query,
      structuredRfvTestGroup: structuredReasonForVisit ? 'test' : 'control',
      isQueryAStructuredRfv: isAStructuredRfv(universalSearch.query, universalSearch.results),
    });
    dispatch({ type: REQUEST_UNIVERSAL_SEARCH, fromSrp: false });
  };

  return (
    <>
      <UniversalInput tab="inPerson" touched={touched} />
      <LocationInput collapseOnMobile />
      <WhenInput collapseOnMobile constrainToWidth="250px" />
      <PatientInput collapseOnMobile constrainToWidth="150px" />
      <SearchButton onSearch={search} />
    </>
  );
};

export default InPersonForm;
